import {Injectable} from '@angular/core';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {EmployeeExpenses, IEmployeeExpenses} from 'app/blocks/model/employee-expenses';
import {Router} from '@angular/router';
import {Resource} from 'app/constants/resource';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {EmployeeExpensesService} from 'app/blocks/service/api/employee-expenses.service';

@Injectable({
    providedIn: 'root'
})
export class EmployeeExpenseResource extends AbstractEntityResource<IEmployeeExpenses> {
    constructor(employeeExpenseService: EmployeeExpensesService, router: Router) {
        super(
            Resource.EMPLOYEE_EXPENSES,
            employeeExpenseService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.EMPLOYEE_EXPENSES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.EMPLOYEE_EXPENSES),
            (entity?) => new EmployeeExpenses(entity),
            (entity) => entity.id
        );
    }
}
